<template>
  <div class="the-navbar__user-meta flex items-center" v-if="adminMenu.length > 0">

    <vs-dropdown vs-custom-content vs-trigger-click class="cursor-pointer">

      <feather-icon icon="SlidersIcon" class="cursor-pointer" />

      <vs-dropdown-menu class="vx-navbar-dropdown" style="width: 230px!important;">
        <ul style="min-width: 9rem">

          <li v-for="menu in adminMenu" :key="menu.route"
            class="flex py-2 px-4 cursor-pointer hover:bg-primary hover:text-white"
            @click="triggerMenu(menu.route)">
            <feather-icon :icon="menu.icon" svgClasses="w-4 h-4" />
            <span class="ml-2">{{ $t(`TITLE.${menu.title}`) }}</span>
          </li>

        </ul>
      </vs-dropdown-menu>
    </vs-dropdown>
  </div>
</template>

<script>
// import firebase from 'firebase/app'
// import 'firebase/auth'
import { getApplicationLocalStorageItem } from '../../../../helpers'

export default {
  data () {
    return {

    }
  },
  computed: {
    activeUserInfo () {
      return this.$store.state.AppActiveUser
    },
    adminMenu () {
      return this.$store.state.auth.adminMenu
    }
  },
  methods: {
    validUrl (url) {
      const pattern = new RegExp('^(https?:\\/\\/)?' +
      '((([a-z\\d]([a-z\\d-]*[a-z\\d])*)\\.)+[a-z]{2,}|' +
      '((\\d{1,3}\\.){3}\\d{1,3}))' +
      '(\\:\\d+)?(\\/[-a-z\\d%_.~+]*)*' +
      '(\\?[;&a-z\\d%_.~+=-]*)?' +
      '(\\#[-a-z\\d_]*)?$', 'i')
      return !!pattern.test(url)
    },
    triggerMenu (route) {
      this.$router.push(route).catch(() => {})
      document.querySelector('#admin-config').click()
    },
    onImageError () {
      this.$store.commit('auth/SET_USER_PHOTO', '/')
    },
    logout () {

      // if user is logged in via auth0
      // this.$vs.loading()
      if (this.$auth.profile) this.$auth.logOut()

      // if user is logged in via firebase
      // const firebaseCurrentUser = firebase.auth().currentUser

      // if (firebaseCurrentUser) {
      //   firebase.auth().signOut().then(() => {
      //     this.$router.push('/login').catch(() => {})
      //   })
      // }
      // If JWT login
      if (getApplicationLocalStorageItem('accessToken')) {
        this.$store.dispatch('auth/signOut')
        // this.$vs.loading.close()
      }

      // Change role on logout. Same value as initialRole of acj.js
      this.$acl.change('admin')
      localStorage.removeItem('userInfo')

      // This is just for demo Purpose. If user clicks on logout -> redirect
      // this.$router.push('/login').catch(() => {})
    }
  }
}
</script>
